<template>
  <div v-if="myDataObj" id="containerId" class="container">
    <!-- 基本信息容器 -->
    <PersonalContainer
      :my-data-obj="myDataObj"
      :activity-name="myDataObj.activityName"
      :evaluator="myDataObj.evaluator"
      :timer="myDataObj.timer"
      :report-type="1"
      :is-hidden-btn="isHiddenBtn"
      :is-export="isExport"
    />
    <!-- 具体量表容器 -->
    <div v-if="myDataObj.papers" class="itemResultContainer">
      <div v-for="(paper, index) in myDataObj.papers" :key="index">
        <el-divider class="dividerONE">
          <h1>{{ paper.name }}</h1>
        </el-divider>
        <div v-for="(item, index1) in paper.detailResult.scales" :key="index1">
          <TitleBar :title="item.name + '    ' + item.score + '    ' + item.conclusion" :is-warn="item.warnLevel > 0" />
          <div class="itemBox">
            <ContentBox :content="item.myExplain" />
          </div>
          <el-table :data="item.answers" border style="width: 100%">
            <el-table-column prop="orderNum" align="center" label="选项" width="180" />
            <el-table-column prop="topicName" align="center" label="题目" />
            <el-table-column prop="topicOptionText" align="center" label="答项" />
            <el-table-column prop="optionScore" align="center" label="分数" width="180" />
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PersonalContainer from '@/components/personalContainer'
import { mixins } from '../../utils/mixins'
import { getWarnReportData } from '../../api/report'
// 使用文件别名引入
import 'styles/reset.css'
// 自定义公共类
import 'styles/common.css'

export default {
  name: 'WarnReport',
  components: {
    PersonalContainer
  },
  mixins: [mixins],
  data() {
    return {
      myDataObj: undefined // 个案网络请求回来的数据
    }
  },
  mounted() {
    // 个案数据网络请求
    this.ws_geCaseReportDataNetWorkAction()
  },
  methods: {
    // 个案数据网络请求
    ws_geCaseReportDataNetWorkAction() {
      var that = this
      getWarnReportData(that.queryParams).then(
        (res) => {
          // 成功
          if (res.code === 200) {
            that.myDataObj = res.data
          }
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~styles/commonPage.scss";

.dividerONE {
  width: 100%;
  height: 2px;
  background-color: #5656d4;
  margin-top: 60px;
}

.dividerONE h1 {
  font-size: 15px;
  //letter-spacing: 2px;
  color: $ws-mainColor;
  font-weight: bold;
  line-height: 45px;
  font-family: '宋体';
  white-space: nowrap;
}

.el-divider__text.is-center {
  background-color: #ebeff8;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
}
</style>
